<ion-header>
    <app-header [backRoute]="['home-multi']"></app-header>
</ion-header>
<ion-content [fullscreen]="true">
    <div class="social-wrap page-width-and-shadow">
        <iframe *ngIf="!!url" [src]="url | safeUrl" style="border:none;" allow="encrypted-media" credentialless></iframe>
    </div>
</ion-content>
